module.exports = new __parcel__URL__("cmp-epic-panel-details.tpl.3aa68d36.svg").toString();